
export function standardizeAnswer(answer, options = {}) {
    const { emptyLetters = true } = options;
    const words = answer.split(' ');
    const letters = words.map(word => {
        return word.split('').map((letter) => { return emptyLetters ? createLetter('') : createLetter(letter.toUpperCase()) });
    })
    return letters;
}

export function standardizeWithoutCorrectWords(letterAnswer, correctAnswer) {
    const standardizeCorrectAnswer = standardizeAnswer(correctAnswer, { emptyLetters: false });
    const letters = letterAnswer.map((word, indexWord) => {
        const isWordCorrect = word.every((letter, indexLetter) =>
            letter.value === standardizeCorrectAnswer[indexWord][indexLetter].value
        );
        return word.map(letter => {
            if (isWordCorrect) {
                return createLetter(letter.value, { disabled: true });
            } else {
                if (letter.disabled) {
                    return letter;
                }
                return createLetter('');
            }
        });
    });
    return letters;
}

export function createLetter(value, options = {}) {
    const { disabled = false, ...rest } = options;
    return {
        value,
        disabled,
        ...rest
    }
}

export function getFirstNotDisabledWordIndex(letterAnswer) {
    return letterAnswer.findIndex(word => word.some(letter => !letter.disabled));
}

export function recoverOriginalAnswer(letters) {
    return letters.map(word => word.map(letters => letters.value).join('')).join(' ');
}

export function normalizeString(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function isAllInputsFilled(phrase) {
    return !phrase.find(word => word.find(letter => letter.value === ''));
}

export function isAccent(character) {
    return character.normalize('NFD').replace(/\p{Diacritic}/gu, "").length < character.length;
}

function getRandomIndex(max) {
    return Math.floor(Math.random() * max);
}

function isDisabledLetter(letter) {
    return letter?.disabled ?? false;
}

export function getIndexRevealLetter(currentInputValue, correctAnswer) {
    const newLettersAnswer = [...currentInputValue];
    const randomizeIndexWord = getRandomIndex(newLettersAnswer.length);
    const randomizeIndexLetter = getRandomIndex(newLettersAnswer[randomizeIndexWord].length);
    if (isDisabledLetter(newLettersAnswer[randomizeIndexWord][randomizeIndexLetter])) return getIndexRevealLetter(currentInputValue, correctAnswer);
    return { wordIndex: randomizeIndexWord, letterIndex: randomizeIndexLetter };
}

export function removeClueLetters(answer) {
    return answer.map(word => word.map(letter => {
        delete letter.isClue;
        return letter;
    }))
}